import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyDatepickerModule } from '@vendasta/galaxy/datepicker';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { VaFilterModule, VaMaterialTableModule, VaStencilsModule } from '@vendasta/uikit';
import { FilterModule } from '@vendasta/va-filter2';
import En from './assets/i18n/en_devel.json';
import { ChangeInvoiceStatusDialogComponent } from './change-invoice-status-dialog/change-invoice-status-dialog.component';
import { WEBLATE_COMPONENT_NAME } from './constants';
import { InvoiceService } from './invoice.service';
import { InvoiceComponent } from './invoice/invoice.component';
import { PaymentFormComponent } from './invoice/payment-form/payment-form.component';
import { ScriptLoaderService } from './payment-method/stripe.service';
import { RecurringInvoiceTableComponent } from './recurring-invoice-table/recurring-invoice-table.component';
import { InvoiceSourcePipe, PadInvoiceNumberPipe, PaymentStatusBadgePipe, PricePipe } from './shared/pipes';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { PaymentTypeToTitlePipe } from './payment-method/select-payment-method-dialog/payment-type-to-title.pipe';
import { KeysPipe } from './payment-method/select-payment-method-dialog/keys.pipe';

@NgModule({
  declarations: [
    ChangeInvoiceStatusDialogComponent,
    InvoiceSourcePipe,
    InvoiceComponent,
    RecurringInvoiceTableComponent,
    PaymentFormComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: En,
    }),
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTooltipModule,
    RouterModule,
    GalaxySnackbarModule,
    VaFilterModule,
    VaStencilsModule,
    VaMaterialTableModule,
    FilterModule,
    MatRadioModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    GalaxyInputModule,
    MatToolbarModule,
    GalaxyPipesModule,
    GalaxyDatepickerModule,
    MatSelectModule,
    GalaxyWrapModule,
    MatCardModule,
    MatGridListModule,
    MatProgressBarModule,
    GalaxyBadgeModule,
    GalaxyEmptyStateModule,
    GalaxyPipesModule,
    GalaxyFormFieldModule,
    GalaxyTooltipModule,
    PaymentStatusBadgePipe,
    PadInvoiceNumberPipe,
    GalaxyButtonLoadingIndicatorModule,
    PaymentTypeToTitlePipe,
    KeysPipe,
    PricePipe,
  ],
  exports: [
    PricePipe,
    InvoiceComponent,
    RecurringInvoiceTableComponent,
    PaymentStatusBadgePipe,
    PaymentTypeToTitlePipe,
    KeysPipe,
    InvoiceSourcePipe,
  ],
  providers: [InvoiceService, ScriptLoaderService],
})
export class SMBInvoicingModule {}
